export default __webpack_public_path__ + "static/media/11-min.966831ff.jpg";